module.exports = __webpack_public_path__ + "semantic/1613d9c6107b2f4dcec2d19e854f73ae.css";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=semantic/[hash].[ext]!./semantic/dist/semantic.min.css
// module id = 359
// module chunks = 0